<template>
	<div class="v-container">
		<div class="v-page-header">作品分类管理</div>
		<div class="v-header">
			<el-button size="small" type="primary" @click="showAdd()">新增分类</el-button>
			<el-button size="small" type="warning" @click="isShowSetting = true">分类设置</el-button>
		</div>
		<div v-loading="loading" class="v-content">
			<el-table size="small" border :data="lists" height="100%">
				<el-table-column label="ID" prop="id" width="50"></el-table-column>
				<el-table-column label="排序" prop="sort" width="80"></el-table-column>
				<el-table-column label="图标" prop="name" width="100" algin="center">
					<div slot-scope="scope" class="icon" :style="{backgroundColor:scope.row.mapType == 2 ? 'transparent' : scope.row.color}">
						<div class="img" :style="{backgroundImage:`url(${scope.row.mapType == 2 && scope.row.iconGrayPreview ? scope.row.iconGrayPreview : scope.row.iconPreview})`}"></div>
					</div>
				</el-table-column>
				<el-table-column label="全称" prop="name"></el-table-column>
				<el-table-column label="简称" prop="alias"></el-table-column>
				<el-table-column align="center" label="操作" width="150">
					<template slot-scope="scope">
						<el-button size="min" class="v-ml-5" type="warning" @click="showAddEdit(scope.row)">编辑</el-button>
						<el-popconfirm title="确认删除？" @onConfirm="doDelete(scope.row)">
							<el-button slot="reference" :disabled="scope.row.all" size="min" class="v-ml-5" type="danger" :loading="scope.row.deleteLoading">删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<add-edit v-if="isShowAddEdit" :show.sync="isShowAddEdit" :row="row" @success="getList" />
		<category-setting v-if="isShowSetting" :show.sync="isShowSetting" @success="getOption"/>
	</div>
</template>

<script>
	import addEdit from "./components/add-edit";
	import categorySetting from "./components/category-setting";
	import  configPage from "@/assets/js/configPage";

	export default {
		components: {addEdit, categorySetting},

		data() {
			return {
				loading: false,
				lists: [],
				row: null,
				isShowAddEdit: false,
				isShowSetting: false,
        all:{id:'-',sort:'-',all:true},
			};
		},
		async created() {
			await this.getOption();
			this.getList();
		},

		methods: {
			async getOption() {
				this.loading = true;
				try {
					let res = await this.api.option.get({name: 'category'});
					if(res && res.data){
						this.all.color = res.data.bgColor;
						this.all.name = this.all.alias =  res.data.name;
						this.all.iconPreview = res.data.icon;
					}else{
						let { category } = configPage;
						this.all.color = category.bgColor;
						this.all.name = this.all.alias =  category.name;
						this.all.iconPreview = category.icon;
          }
					this.lists[0] = this.all;
				} catch (e) {
					console.error(e)
				}
				this.loading = false;
			},

			async getList() {
				this.loading = true;
				try {
					let res = await this.api.category.lists();
					this.lists = [];
					this.lists = [this.all].concat(res.data);
				} catch (e) {
					console.error(e);
				}
				this.loading = false;
			},

			showAdd() {
				this.row = null;
				this.isShowAddEdit = true;
			},

			showAddEdit(row) {
				this.row = row;
				if(row.all){
					this.isShowSetting = true;
        }else{
					this.isShowAddEdit = true;
        }
			},

			//删除
			async doDelete(row) {
				this.$set(row, "deleteLoading", true);
				try {
					await this.api.category.delete({id: row.id});
					this.$message.success("删除成功");
					this.getList();
				} catch (e) {
					console.error(e);
				}
				this.$set(row, "deleteLoading", false);
			}
		}
	};
</script>

<style scoped>
	.icon {
		border-radius: 100%;
		width: 40px;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.icon .img {
		width: 22px;
		height: 22px;
		background-position: center center;
		background-repeat: no-repeat;
		background-size: contain;
	}
</style>
